#import "../fragments/calendar-fragment.graphql"

mutation UpdateCalendarContactCreationRule($calendarId: ID!, $isContactCreationDisabled: Boolean!) {
    calendarContactCreationRuleUpdate(
        calendarId: $calendarId
        isContactCreationDisabled: $isContactCreationDisabled
    ) {
        calendar {
            ...CalendarFragment
        }
    }
}
